import {BASE_SINGLE_ARG_NUMERIC_FUNCTION} from 'pipelines/formula/functions/BaseFunctions';

import {AnalysisFunction} from '../FunctionTypes';

export default {
  ...BASE_SINGLE_ARG_NUMERIC_FUNCTION,
  name: 'FLOOR',
  description: 'Rounds down each number in a column or a single number to the closest integer.',
  shortDescription: 'Rounds down',
} satisfies AnalysisFunction;
